import { EventoCliente } from "features/cliente/clienteConstants";

export enum NotificationType {
  ClientAccess = "client-access",
  PendingMovements = "pending-movements",
}

export type NotificationItem = {
  action?: () => void;
  actionOnShow?: () => void;
  description?: string | JSX.Element;
  icon?: JSX.Element;
  id: string;
  title: string | JSX.Element;
  type: NotificationType;
};

export type SuspendedClient = {
  eventDate: string | null;
  event: keyof typeof EventoCliente;
  id: number;
  name: string;
};
